export default "__VITE_ASSET__vVxwMuKz__"